module.exports = __webpack_public_path__ + "cg.e90d0f7391fabcbe56bd.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/cg.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/cg.svg
// module chunks = styles